<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'clientes') {
            next({ name: 'clientes-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'clientes') {
            this.$router.replace({ name: 'clientes-list' });
        }
    },
};
</script>
